<div class="login-wrapper">
  <app-loader [isLoading]="isLoading"></app-loader>

  <div class="login-container">
    <form (ngSubmit)="onSubmit()" class="form" [formGroup]="loginForm">
      <div class="brand">
        <p>ParkingHub by</p>
        <img
          width="100"
          height="40"
          src="assets/mosten-logo.svg"
          alt="Mosten Logo" />
      </div>

      <h1>Bem-vindo!</h1>

      <div class="form-group">
        <app-input
          [label]="
            currentUserType === 'FUNC' ? 'Email ou usuário' : 'Email'
          "
          name="TX_MAIL"
          formControlName="TX_MAIL"
          [placeholder]="
            currentUserType === 'FUNC'
              ? 'exemplo@email.com.br ou usuario'
              : 'exemplo@email.com.br'
          "></app-input>
        <app-input
          type="password"
          label="Senha"
          name="TX_SENHA"
          formControlName="TX_SENHA"
          placeholder="Digite aqui"></app-input>
      </div>

      <login-switch
        [userType]="currentUserType"
        (userTypeChanged)="onUserTypeChanged($event)">
      </login-switch>

      <div class="checkbox-container">
        <label class="forgot-password" (click)="goTo('/recuperar-senha')">
          Esqueceu a senha?
        </label>
      </div>

      <app-botao
        class="button"
        type="primario"
        width="100%"
        text="Entrar"
        (click)="onSubmit()" />

      <app-botao
        *ngIf="currentUserType !== 'FUNC'"
        class="button"
        type="secundario"
        width="100%"
        text="Cadastrar usuário"
        (click)="goToCreateUser()" />
    </form>

    <p class="terms-text">
      Ao acessar, você concorda com os nossos
      <a href="#" id="link-termo-uso">termo de uso</a> e
      <a href="#" id="link-termo-consentimento">termo de consentimento</a>.
    </p>
  </div>

  <div class="image-container">
    <img
      class="image"
      [src]="brand.logoLogin"
      [class.image-wordmark]="brand.isMosten"
      alt="ParkingHub Logo" />
  </div>
</div>
